<template>
    <div>
        <button id="back-30s" @click="back30s"></button>
        <button id="fs-laptop"></button>
    </div>
</template>

<script>
    export default {
        name: "BackButton",
        methods: {
            back30s() {
                this.$parent.video.currentTime = this.$parent.video.currentTime - 30;
                this.$parent.video.play()
            }
        }
    }
</script>

<style lang="scss" scoped>
    #back-30s {
        border-radius: 25px;
        border: none;
        outline: none;
        cursor: pointer;
        background-color: transparent;
        position: absolute;
        top: 78%;
        left: 20%;
        width: 10%;
        height: 5%;
        transform: rotate(-3deg);
        z-index: 1;
    }

    #fs-laptop {
        border-radius: 25px;
        border: none;
        outline: none;
        cursor: pointer;
        background-color: transparent;
        position: absolute;
        top: 77%;
        left: 30%;
        width: 10%;
        height: 5%;
        z-index: 1;
        transform: rotate(-3deg);
    }
</style>